// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltipbox .arrow-container[data-v-3004d29b]{left:50%;transform:translate(-50%,calc(50% + .75rem)) scaley(.75)}.tooltipbox .is-top.arrow-container[data-v-3004d29b]{transform:translate(-50%,calc(-50% - .75rem)) scaley(.75)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
